<template>
    <div class="page">
        <map-editor></map-editor>
        <right-editor/>
    </div>
</template>
<script>
import MapEditor from './_map'
import RightEditor from './_editor'

export default {
    components: {
        MapEditor,
        RightEditor
    },
    async mounted () {
        setTimeout(() => {
            this.$store.dispatch('MetroEditor/init', this.$route.params.id)
        }, 3000)
    }
}
</script>
<style lang="scss" scoped>
.page {
    display: flex;
    width: 100%;
    height: 100vh;
}
</style>
